var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.00004 13.6668C3.31804 13.6668 0.333374 10.6822 0.333374 7.00016C0.333374 3.31816 3.31804 0.333496 7.00004 0.333496C10.682 0.333496 13.6667 3.31816 13.6667 7.00016C13.6667 10.6822 10.682 13.6668 7.00004 13.6668ZM7.00004 12.3335C8.41453 12.3335 9.77108 11.7716 10.7713 10.7714C11.7715 9.7712 12.3334 8.41465 12.3334 7.00016C12.3334 5.58567 11.7715 4.22912 10.7713 3.22893C9.77108 2.22873 8.41453 1.66683 7.00004 1.66683C5.58555 1.66683 4.229 2.22873 3.2288 3.22893C2.22861 4.22912 1.66671 5.58567 1.66671 7.00016C1.66671 8.41465 2.22861 9.7712 3.2288 10.7714C4.229 11.7716 5.58555 12.3335 7.00004 12.3335ZM6.33337 9.00016H7.66671V10.3335H6.33337V9.00016ZM6.33337 3.66683H7.66671V7.66683H6.33337V3.66683Z",
    fill: "#FF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.8af0d62cde703d0da0e1a557b5a05c30.svg";
export { ForwardRef as ReactComponent };